<template>
  <div style="height:100%;padding:10px;text-align:center;">
    <Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <Icon type="md-create" />
        <span>检索条件</span>
      </p>
      <div style="text-align:center">
        <div>
          <Row>
            <Col span="12">
              <span>地址</span>
            </Col>
            <Col span="12">
              <Cascader
                v-model="searchItems.addressSelected"
                :data="addressData"
                style="width: 158px;margin-left: 4px;padding-left:8px"
                trigger="hover"
                placeholder="请选择地址"
                @on-change="selectSearchAddress"
                filterable
              ></Cascader>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <span>户主</span>
            </Col>
            <Col span="12">
              <Input v-model="searchItems.customerName" placeholder="请输入户主姓名" style="width: 150px" />
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <span>表号</span>
            </Col>
            <Col span="12">
              <Input v-model="searchItems.meterId" placeholder="请输入表号" style="width: 150px" />
            </Col>
          </Row>
        </div>
      </div>
      <div slot="footer">
        <Button type="info" size="large" @click="searchByCondition" long>检索</Button>
      </div>
    </Modal>

    <Spin fix v-show="isSpinShow" size="large" />
    <Steps :current="current" :offset-top="20">
      <Step title="选择操作类型"></Step>
      <Step title="填写工单信息"></Step>
      <Step title="操作结果提示"></Step>
    </Steps>
    <div v-if="showStep2&&formValidate.orderType!='安装'">
      <br />
      <Row style="padding:10px 0px 0px 0px;margin-bottom: 10px">
        <Col span="3" style="padding:0px 5px 0px 0px">
          <Button long type="primary" @click="modal8 = true">检索条件</Button>
        </Col>
      </Row>
      <Table size="large" border stripe :loading="loading" :columns="columns1" :data="data1">
        <template slot-scope="{ row, index }" slot="appointment">
          <Tooltip
            placement="top"
            :disabled="row.appointmentdate == undefined|| row.appointmentdate == ''"
            transfer
            :content="
                (()=>{
                  if(row.appointmentdate != undefined && row.appointmentdate != ''){
                    
                    return dateFtt('yyyy-MM-dd hh:mm:ss', row.appointmentdate);
                  }
                })()
                "
          >
            <DatePicker
              v-model="row.appointmentdate"
              transfer
              type="datetime"
              placeholder="请选择预约时间"
            ></DatePicker>
          </Tooltip>
        </template>
        <template slot-scope="{ row, index }" slot="implement">
          <Select v-model="row.personnel" transfer placeholder="请选择施工人">
            <Option
              v-for="item in engineers"
              v-if="item.personnelGroverningBodyId == row.addressGoverningBody"
              :value="JSON.stringify(item)"
              :key="item.personnelSeriesNumber"
            >{{item.personnelName + " " + item.personnelPhone}}</Option>
          </Select>
        </template>
        <template slot-scope="{ row, index }" slot="save">
          <Checkbox
            label="twitter"
            :id="formValidate.orderType == '安检'?row.checkHistoryId : row.repairHistoryId"
            type="primary"
            shape="circle"
            @on-change="saveDate(row, index, $event)"
          ></Checkbox>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Row>
            <Col span="12">
              <Input v-model="row.workOrderCycle"></Input>
            </Col>
            <Col span="12">
              <Select v-model="row.workOrderCycleUnit" transfer>
                <Option value="天">天</Option>
                <Option value="周">周</Option>
                <Option value="月">月</Option>
                <Option value="年">年</Option>
              </Select>
            </Col>
          </Row>
          <!-- <Button type="primary" shape="circle" icon="ios-apps" @click="showData(row, index)"></Button> -->
        </template>
      </Table>
      <br />
      <Page
        :current="pageNo"
        :total="pageTotal"
        :page-size="pageSize"
        :page-size-opts="[5, 10, 20, 30, 40]"
        show-sizer
        show-total
        @on-change="changePage"
        @on-page-size-change="changePageSize"
      />
    </div>
    <div style="width:50%; left:25%; position:relative; margin-top:15px;">
      <div v-if="showStep3">
        <step3 ref="step3" :result="result" :msg="msg" :on-ok="callBackReturn"></step3>
      </div>
      <div v-if="showStep1">
        <Form
          ref="step1FormValidate"
          :model="formValidate"
          :rules="step1RuleValidate"
          :label-width="100"
          style="text-align:left"
        >
          <FormItem label="操作类型" prop="opType">
            <Select v-model="formValidate.opType" placeholder="请选择操作类型">
              <Option value="创建工单">创建工单</Option>
              <Option value="分配工单">分配工单</Option>
            </Select>
          </FormItem>
          <FormItem label="工单类型" prop="orderType">
            <Select v-model="formValidate.orderType" placeholder="请选择工单类型">
              <Option v-if="formValidate.opType == '创建工单'" value="安装">安装</Option>
              <Option v-if="formValidate.opType != '创建工单'" value="安检">安检</Option>
              <Option v-if="formValidate.opType != '创建工单'" value="维修">维修</Option>
            </Select>
          </FormItem>
          <Divider orientation="left"></Divider>
          <div v-if="formValidate.orderType == '安装'">
            <FormItem label="地址" prop="address">
              <Cascader
                v-model="formValidate.addressSelected"
                :data="addressData"
                trigger="hover"
                placeholder="请选择地址"
                @on-change="selectAddress"
                filterable
              ></Cascader>
            </FormItem>
            <FormItem v-if="formValidate.orderType != '安装'" label="设备" prop="meters">
              <Select v-model="formValidate.meters" placeholder="请选择设备">
                <Option
                  v-for="item in meters"
                  :value="JSON.stringify(item)"
                  :key="item.meterId"
                >{{item.completeAddress + " 设备编号：" + item.meterId}}</Option>
              </Select>
            </FormItem>
          </div>
        </Form>
      </div>

      <div v-if="showStep2&&formValidate.orderType=='安装'">
        <Form ref="formValidate" :model="formValidate" :label-width="100" style="text-align:left">
          <FormItem label="工单类型" prop="opType">
            <Input readonly v-model="formValidate.orderType"></Input>
          </FormItem>
          <FormItem label="施工周期" prop="orderType">
            <Row>
              <Col span="12">
                <Input v-model="formValidate.circle"></Input>
              </Col>
              <Col span="12">
                <Select v-model="formValidate.circleunit">
                  <Option value="天">天</Option>
                  <Option value="周">周</Option>
                  <Option value="月">月</Option>
                  <Option value="年">年</Option>
                </Select>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="工单备注">
            <Input
              v-model="formValidate.remark"
              type="textarea"
              :autosize="{minRows: 2,maxRows: 5}"
              placeholder="请输入备注"
            ></Input>
          </FormItem>
          <Divider orientation="left"></Divider>
          <FormItem label="施工人" prop="personnel">
            <Select v-model="formValidate.personnel" placeholder="请选择施工人">
              <Option
                v-for="item in engineers"
                :value="JSON.stringify(item)"
                :key="item.personnelSeriesNumber"
              >{{item.personnelName + " " + item.personnelPhone}}</Option>
            </Select>
          </FormItem>
          <div v-if="formValidate.orderType != '安装'">
            <Divider orientation="left"></Divider>
            <FormItem label="预约时间" prop="opType">
              <Tooltip
                placement="top"
                :disabled="timeStampModel == undefined || timeStampModel[0] == ''"
                transfer
                :content="
                (()=>{
                  if(formValidate.appointmentdate != undefined && formValidate.appointmentdate != ''){
                    
                    return dateFtt('yyyy-MM-dd hh:mm:ss', formValidate.appointmentdate);
                  }else{
                        return '请选择预约时间';
                  }
                })()
                "
              >
                <DatePicker
                  v-model="formValidate.appointmentdate"
                  type="datetime"
                  placeholder="请选择预约时间"
                ></DatePicker>
              </Tooltip>
            </FormItem>
          </div>
        </Form>
      </div>

      <div style="right:  70px;margin-top:15px">
        <Button v-if="showStep2" style="margin-left: 20px;" type="primary" @click="pre">上一步</Button>
        <Button v-if="!showStep3" style="margin-left: 20px;" type="primary" @click="next">下一步</Button>
      </div>
    </div>
  </div>
</template>
<script>
import step3 from "./expand/opResult.vue";
import expandRow from "./expand/OrderTableExpand.vue";
export default {
  name: "order_create",
  components: { step3 },
  mounted() {
    // this.tableHeight =
    //   window.innerHeight - this.$refs.table.$el.offsetTop - 160;
    this.getAddresTree();
    this.getAllEngineer();
  },
  created() {},
  methods: {
    // 按条件检索点击事件
    searchByCondition() {
      console.log(this.searchItems);

      // 调用接口查询
      // this.getRecord();
      this.getOrder(
        this.searchItems.meterId,
        this.searchItems.customerName,
        this.searchItems.addressId
      );
      this.modal8 = false;
    },
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, date);
    },
    // 修改页面容量
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.searchByCondition();
      // this.getOrder("");
    },
    // 修改
    changePage(index) {
      this.pageNo = index;
      this.searchByCondition();
      // this.getOrder("");
    },

    saveDate(row, index, event) {
      var id = "";
      if (this.formValidate.orderType == "安检") {
        id = row.checkHistoryId;
      } else if (this.formValidate.orderType == "维修") {
        id = row.repairHistoryId;
      }

      // $("#" + id).parents(".ivu-table-row").find(".ivu-checkbox-checked").removeClass("ivu-checkbox-checked");
      // console.log($("#" + id).find("span").removeClass("ivu-checkbox-checked"));

      this.savedData[id] = row;
      console.log(this.savedData);
      // $("#" + id)[0].disabled = true;
      // $("#" + id)
      //   .parents(".ivu-table-row")
      //   .find("input")
      //   .css("display", "none");
      // $("#" + id)
      //   .parents(".ivu-table-row")
      //   .find(".ivu-select")
      //   .addClass("ivu-select-disabled");
      // $("#" + id)
      //   .parents(".ivu-table-row")
      //   .find(".ivu-select-selection")
      //   .css("display", "none");
      // $("#" + id).parents('.ivu-table-row').css("display", "none");

      // if(event.target.localName == 'span'){

      //   var btn = event.target.parentElement;
      //   console.log(event);
      //   console.log(event.target);
      //   btn.target.disabled = true;
      // }else{
      //   event.target.disabled = true;
      // }
    },
    showData(row, index) {
      console.log(row);
    },
    callBackReturn() {
      this.current = 0;
      this.showStep1 = true;
      this.showStep2 = false;
      this.showStep3 = false;
    },
    selectAddress(selectedData) {
      this.getMeters(selectedData[selectedData.length - 1]);
      this.getEngineer(selectedData[selectedData.length - 1]);
    },
    selectSearchAddress(selectedData) {
      this.searchItems.addressId = selectedData[selectedData.length - 1];
    },
    selectMeter(selectMeter) {
      var meterId = selectMeter.meterId;
      this.getOrder(meterId);
    },

    createInstallOrder() {
      if (
        this.formValidate.circle * 1 != this.formValidate.circle * 1 ||
        this.formValidate.circle * 1 == 0
      ) {
        this.$Notice.error({
          title: "提示",
          desc: "请输入正确的施工工期"
        });
        return;
      }
      if (
        this.formValidate.personnel == undefined ||
        this.formValidate.personnel == ""
      ) {
        this.$Notice.info({
          title: "提示",
          desc: "请选择施工人！"
        });
        return;
      }
      this.isSpinShow = true;
      var that = this;
      $.ajax({
        url: "/api/createInstallOrder",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          address: that.formValidate.addressInfoId,
          orderRemark: that.formValidate.remark,
          orderCircleUnit: that.formValidate.circleunit,
          orderCircle: that.formValidate.circle,
          personnel: that.formValidate.personnel
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            that.result = "fail";
            return;
          }

          //   that.meters = data.body;
          that.msg = "工单创建成功<br/>工单编号为" + data.body.orderKey;
          that.result = "success";
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "创建工单异常"
          });
          that.result = "fail";
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
          that.showStep2 = false;
          that.current++;
          that.showStep3 = true;
          that.$refs.step3.changeStatus(that.result);
        }
      });
    },

    distributionRepairOrder() {
      this.isSpinShow = true;
      var that = this;
      $.ajax({
        url: "/api/distributionRepairOrder",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          distribution: that.savedData
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: "分配维修工单异常"
            });
            that.result = "fail";
            return;
          }

          that.savedData = {};
          //   that.meters = data.body;
          that.msg = "分配维修工单成功";
          that.result = "success";
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "分配维修工单异常"
          });
          that.result = "fail";
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
          that.showStep2 = false;
          that.current++;
          that.showStep3 = true;
          that.$refs.step3.changeStatus(that.result);
        }
      });
    },

    distributionCheckOrder() {
      this.isSpinShow = true;
      var that = this;
      $.ajax({
        url: "/api/distributionCheckOrder",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          distribution: that.savedData
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: "分配安检工单异常"
            });
            that.result = "fail";
            return;
          }

          that.savedData = {};
          //   that.meters = data.body;
          that.msg = "分配安检工单成功";
          that.result = "success";
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "分配安检工单异常"
          });
          that.result = "fail";
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
          that.showStep2 = false;
          that.current++;
          that.showStep3 = true;
          that.$refs.step3.changeStatus(that.result);
        }
      });
    },

    getAllEngineer() {
      var that = this;
      $.ajax({
        url: "/api/getAllEngineer",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          //   that.meters = data.body;
          that.engineers = data.body;
          console.log(data.body);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "获取施工人员异常"
          });
        }
      });
    },
    getEngineer(addressId) {
      var that = this;
      $.ajax({
        url: "/api/getEngineerByAddress",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          addressId: addressId
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          //   that.meters = data.body;
          that.engineers = data.body.personneList;
          that.formValidate.addressInfoId = data.body.addressInfoId;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "获取施工人员异常"
          });
        }
      });
    },
    getOrder(meterId, customerName, addressId) {
      var that = this;
      that.pageNo = 1;
      that.isSpinShow = true;
      that.loading = true;
      $.ajax({
        url: "/api/getOrderListByCondition",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          meterId: meterId,
          type: that.formValidate.orderType,
          page: that.pageNo,
          amount: that.pageSize,
          customerName: customerName,
          addressId: addressId
        }),
        success: function(data) {
          that.savedData = {};
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: "工单获取异常"
            });
            return;
          }

          that.data1 = data.body.resultArray;
          that.pageTotal = data.body.count;
          that.data1.map(item => {
            if (!item.workOrderCycleUnit) {
              item.workOrderCycleUnit = "天";
            }
          });

          if (
            that.formValidate.orderType == "安检" ||
            that.formValidate.orderType == "维修"
          ) {
            for (let i = 0; i < that.data1.length; i++) {
              that.dList[that.data1[i].checkHistoryId] = false;
            }
          }

          console.log(data);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "工单获取异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
          that.loading = false;
        }
      });
    },

    getMeters(addressId) {
      var that = this;
      $.ajax({
        url: "/api/getMetersByAddress",
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify({
          addressId: addressId
        }),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.meters = data.body;
          console.log(data);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "地址获取异常"
          });
        }
      });
    },

    getAddresTree() {
      var that = this;
      $.ajax({
        url: "/api/getAddressTree",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.addressData = data.body[0].children;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "地址获取异常"
          });
        }
      });
    },
    pre() {
      if (this.current == 0) {
      } else {
        this.current -= 1;
        this.showStep1 = false;
        this.showStep2 = false;
        this.showStep3 = false;

        switch (this.current) {
          case 0:
            this.showStep1 = true;
            break;
          case 1:
            this.showStep2 = true;
            break;
          case 2:
            this.showStep3 = true;
            break;
        }
      }
    },
    next() {
      if (this.formValidate.orderType == undefined) {
        this.$Notice.error({
          title: "提示",
          desc: "请先选择工单类型"
        });
        return;
      }

      if (this.current == 2) {
        // this.current = 0;
      } else {
        console.log(this.formValidate.addressSelected);
        console.log(this.formValidate.meters);
        if (this.current == 0) {
          if (
            this.formValidate.orderType == "安装" &&
            this.formValidate.addressSelected != ""
          ) {
            this.step1Result = true;
          } else if (
            this.formValidate.orderType != "安装"
            // &&
            // this.formValidate.addressSelected != "" &&
            // this.formValidate.meters != ""
          ) {
            this.step1Result = true;
          } else {
            this.step1Result = false;
            this.$Notice.warning({
              title: "提示",
              desc: "请完善工单信息"
            });
          }

          if (!this.step1Result) {
            return;
          }
        }

        if (this.current == 1) {
          if (this.formValidate.orderType == "安装") {
            this.createInstallOrder();
          }
          var canContinue = true;
          if (
            this.formValidate.orderType == "安检" ||
            this.formValidate.orderType == "维修"
          ) {
            var that = this;

            Object.keys(that.savedData).forEach(function(key) {
              let row = that.savedData[key];
              if (
                row.workOrderCycle == "" ||
                row.workOrderCycle == undefined ||
                row.workOrderCycleUnit == "" ||
                row.workOrderCycleUnit == undefined ||
                row.appointmentdate == "" ||
                row.appointmentdate == undefined ||
                row.personnel == "" ||
                row.personnel == undefined
              ) {
                that.$Notice.error({
                  title: "提示",
                  desc: "请完善工单消息"
                });
                canContinue = false;
                return;
              }

              if (row.workOrderCycle <= 0) {
                that.$Notice.info({
                  title: "提示",
                  desc: "请填写正确的施工周期"
                });
                canContinue = false;
                return;
              }

              if (new Date(row.appointmentdate) < new Date()) {
                that.$Notice.info({
                  title: "提示",
                  desc: "请选择正确的预约时间"
                });
                canContinue = false;
                return;
              }
            });
          }

          if (!canContinue) {
            return;
          }

          if (this.formValidate.orderType == "安检") {
            if (Object.keys(this.savedData).length == 0) {
              this.$Notice.error({
                title: "提示",
                desc: "请先保存需要分配的工单"
              });
              return;
            }
            this.distributionCheckOrder();
          }
          if (this.formValidate.orderType == "维修") {
            if (Object.keys(this.savedData).length == 0) {
              this.$Notice.error({
                title: "提示",
                desc: "请先保存需要分配的工单"
              });
              return;
            }
            this.distributionRepairOrder();
          }
        }
        if (this.current == 0) {
          if (this.formValidate.orderType == "安检") {
            this.searchItems = {};
            this.getOrder();
          }
          if (this.formValidate.orderType == "维修") {
            this.searchItems = {};
            this.getOrder();
          }
        }

        this.showStep1 = false;
        this.showStep2 = false;
        this.showStep3 = false;
        this.current += 1;

        switch (this.current) {
          case 0:
            this.showStep1 = true;
            break;
          case 1:
            this.showStep2 = true;
            break;
          case 2:
            this.current--;
            this.showStep2 = true;
            // this.showStep3 = true;
            break;
        }
      }
    }
  },
  data() {
    return {
      isSpinShow: false,
      columns1: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row,
                type: this.formValidate.orderType
              }
            });
          }
        },
        {
          title: "地址",
          key: "completeAddress",
          align: "center"
        },
        {
          title: "设备编号",
          key: "meterId",
          align: "center"
        },
        // {
        //   title: "备注",
        //   key: "checkHistoryCheckRemark",
        //   align: "center"
        // },
        {
          title: "设置工期",
          slot: "action",
          align: "center"
        },
        {
          title: "预约时间",
          slot: "appointment",
          align: "center"
        },
        {
          title: "施工人",
          slot: "implement",
          align: "center"
        },
        {
          title: "保存信息",
          slot: "save",
          align: "center"
        }
      ],
      savedData: {},
      dList: {
        // 3:true
      },
      loading: true,
      modal8: false,
      msg: "",
      result: "success",
      meters: [],
      selectedCondition: [],
      data1: [],
      loading: true,
      showDrawer: false,
      selectDataHtml: "",
      selectData: {},
      modal8: false,
      pageTotal: 0,
      pageSize: 5,
      saveIdModel: "",
      deviceIdModel: "",
      commandIdModel: "",
      timeStampModel: "",
      pageNo: 1,
      requestBody: {},
      current: 0,
      showStep1: true,
      showStep2: false,
      showStep3: false,
      step1Result: true,
      addressData: [],
      engineers: [],
      formValidate: {
        opType: "创建工单",
        orderType: "安装",
        circle: 3,
        circleunit: "天",
        appointmentdate: "",
        addressSelected: "",
        meters: "",
        addressInfoId: 0
      },
      searchItems: {
        addressSelected: [],
        customerName: "",
        meterId: "",
        addressId: ""
      },
      step1RuleValidate: {
        meters: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            trigger: "blur"
          }
        ]
      }
    };
  }
};
</script>